var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 85,
    viewBox: "0 0 69 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43939 39.9007V39.9012C7.43939 41.1708 8.33569 42.4424 9.76631 42.4424H27.0513V70.0648H3.54785V39.9012C3.54785 25.688 12.8746 14.1809 24.5036 12.821V17.678C19.9196 18.3243 15.6992 20.8297 12.5861 24.721C9.26994 28.8663 7.44219 34.2897 7.43939 39.9007ZM66.8325 42.4424V70.0648H43.329V39.9012C43.329 25.6876 52.6565 14.1794 64.3113 12.8207V17.6758C54.5765 19.0219 47.2205 28.5751 47.2205 39.9012C47.2205 41.1708 48.1168 42.4424 49.5475 42.4424H66.8325Z",
    stroke: "#2D194E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuote);
export default __webpack_public_path__ + "static/media/icon-quote.a2e3a1b15d456e9b955b2c1f732506e5.svg";
export { ForwardRef as ReactComponent };